import Vue from "vue";
import Router from "vue-router";
// import Home from "./views/Home.vue";
// import Settings from "./views/Settings.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      name: "Page Not Found",
      component: () => import("./views/PageNotFound.vue"),
    },
    {
      path: "/",
      name: "Login",
      component: () => import("./views/Login.vue"),
    },
    {
      path: "/home",
      name: "Home",
      component: () => import("./views/Home.vue"),
    },
    {
      path: "/pages",
      name: "Pages",
      component: () => import("./views/Pages.vue"),
    },
    {
      path: "/roles",
      name: "Roles",
      component: () => import("./views/Roles.vue"),
    },
    {
      path: "/company-roles",
      name: "Company Roles",
      component: () => import("./views/CompanyRoles.vue"),
    },
    {
      path: "/sub-company-roles",
      name: "Sub-Company Roles",
      component: () => import("./views/SubCompanyRoles.vue"),
    },
    {
      path: "/employees",
      name: "Employees",
      component: () => import("./views/Employees.vue"),
    },
    {
      path: "/companies",
      name: "Companies",
      component: () => import("./views/Companies.vue"),
    },
    {
      path: "/devices",
      name: "Devices",
      component: () => import("./views/Devices.vue"),
    },
    {
      path: "/settlements",
      name: "Settlements",
      component: () => import("./views/Settlements.vue"),
    },
    {
      path: "/esales",
      name: "Esales",
      component: () => import("./views/reports/Esales.vue"),
    },
    {
      path: "/remittance-wireless",
      name: "Remittance Wireless",
      component: () => import("./views/reports/RemittanceWireless.vue"),
    },
    {
      path: "/remittance-sync",
      name: "Remittance Sync",
      component: () => import("./views/reports/RemittanceSync.vue"),
    },
    {
      path: "/dispatch-wireless",
      name: "Dispatch Wireless",
      component: () => import("./views/reports/DispatchWireless.vue"),
    },
    {
      path: "/dispatch-sync",
      name: "Dispatch Sync",
      component: () => import("./views/reports/DispatchSync.vue"),
    },
    {
      path: "/arrival-wireless",
      name: "Arrival Wireless",
      component: () => import("./views/reports/ArrivalWireless.vue"),
    },
    {
      path: "/arrival-sync",
      name: "Arrival Sync",
      component: () => import("./views/reports/ArrivalSync.vue"),
    },
    {
      path: "/ticket-wireless",
      name: "Ticket Wireless",
      component: () => import("./views/reports/TicketWireless.vue"),
    },
    {
      path: "/ticket-sync",
      name: "Ticket Sync",
      component: () => import("./views/reports/TicketSync.vue"),
    },
    {
      path: "/inspection-wireless",
      name: "Inspection Wireless",
      component: () => import("./views/reports/InspectionWireless.vue"),
    },
    {
      path: "/inspection-sync",
      name: "Inspection Sync",
      component: () => import("./views/reports/InspectionSync.vue"),
    },
    {
      path: "/ticket-exception-report",
      name: "Ticket Exception Report",
      component: () => import("./views/reports/TicketExceptionReport.vue"),
    },
    {
      path: "/ticket-date-exception",
      name: "Ticket Date Exception",
      component: () => import("./views/reports/TicketDateException.vue"),
    },
    {
      path: "/dispatch-exception-report",
      name: "Dispatch Exception Report",
      component: () => import("./views/reports/DispatchExceptionReport.vue"),
    },
    {
      path: "/trip-manifest",
      name: "Trip Manifest",
      component: () => import("./views/reports/TripManifest.vue"),
    },
    // {
    //   path: "/baggage-wireless",
    //   name: "Baggage Wireless",
    //   component: () => import("./views/sub_company/reports/BaggageWireless.vue")
    // },
    // {
    //   path: "/baggage-sync",
    //   name: "Baggage Sync",
    //   component: () => import("./views/sub_company/reports/BaggageSync.vue")
    // },

    // COMPANY
//
    {
      path: "/c/home",
      name: "Home",
      component: () => import("./views/company/Home.vue"),
    },
    {
      path: "/c/pages",
      name: "Pages",
      component: () => import("./views/company/Pages.vue"),
    },
    {
      path: "/c/roles",
      name: "Roles",
      component: () => import("./views/company/Roles.vue"),
    },
    //access card
    { 
      path: "/c/access-cards",
      name: "Access Cards",
      component: () => import("./views/company/AccessCards.vue"),
    },
    //employees
    {
      path: "/c/employees",
      name: "Employees",
      component: () => import("./views/company/Employees.vue"),
    },
    {
      path: "/c/sub-companies",
      name: "Sub Companies",
      component: () => import("./views/company/SubCompanies.vue"),
    },
    {
      // software-serial
      path: "/c/software-serials",
      name: "Software Serials",
      component: () => import("./views/company/SoftwareSerials.vue"),
    },
    {
      path: "/c/devices",
      name: "Devices",
      component: () => import("./views/company/Devices.vue"),
    },
    {
      path: "/c/terminals",
      name: "Terminals",
      component: () => import("./views/company/Terminals.vue"),
    },
    {
      path: "/c/bounds",
      name: "Bounds",
      component: () => import("./views/company/Bounds.vue"),
    },
    {
      path: "/c/fuel-stations",
      name: "Fuel Stations",
      component: () => import("./views/company/FuelStations.vue"),
    },
    {
      // vehicle-types
      path: "/c/vehicle-types",
      name: "Vehicle Types",
      component: () => import("./views/company/VehicleTypes.vue"),
    },
    {
      path: "/c/vehicle-layouts",
      name: "Vehicle Layouts",
      component: () => import("./views/company/VehicleLayouts.vue"),
    },
    {
      path: "/c/store",
      name: "Store Name",
      component: () => import("./views/company/Vehicles.vue"),
    },
    {
      path: "/c/violations",
      name: "Violations",
      component: () => import("./views/company/Violations.vue"),
    },
    {
      path: "/c/expenses",
      name: "Expenses",
      component: () => import("./views/company/Expenses.vue"),
    },
    {
      path: "/c/passenger-types",
      name: "Passenger Types",
      component: () => import("./views/company/PassengerTypes.vue"),
    },
    {
      path: "/c/payment-types",
      name: "Payment Types",
      component: () => import("./views/company/PaymentTypes.vue"),
    },
    {
      path: "/c/manual-types",
      name: "Manual Types",
      component: () => import("./views/company/ManualTypes.vue"),
    },
    {
      // employees list
      path: "/c/employees-lists",
      name: "Employees Lists",
      component: () => import("./views/company/EmployeesLists.vue"),
    },
    {
      path: "/c/end-of-day",
      name: "End Of Day",
      component: () => import("./views/company/EndOfDay.vue"),
    },
    {
      path: "/c/eod-summary-report",
      name: "EOD Summary Report",
      component: () => import("./views/company/reports/EODSummaryReport.vue"),
    },
    // {
    //   path: "/c/ltfrb-report",
    //   name: "LTFRB Report",
    //   component: () => import("./views/company/reports/LTFRBReport.vue"),
    // },
    // {
    //   path: "/c/executive-report",
    //   name: "Executive Report",
    //   component: () => import("./views/company/reports/ExecutiveReport.vue"),
    // },

    // SUB COMPANY

    {
      path: "/c/s/home",
      name: "Home",
      component: () => import("./views/sub_company/Home.vue"),
    },
    {
      path: "/c/s/pages",
      name: "Pages",
      component: () => import("./views/sub_company/Pages.vue"),
    },
    {
      path: "/c/s/roles",
      name: "Roles",
      component: () => import("./views/sub_company/Roles.vue"),
    },
    {
      //employees
      path: "/c/s/employees",
      name: "Employees",
      component: () => import("./views/sub_company/Employees.vue"),
    },
    {
      path: "/c/s/terminals",
      name: "Terminals",
      component: () => import("./views/sub_company/Terminals.vue"),
    },
    {
      path: "/c/s/bounds",
      name: "Bounds",
      component: () => import("./views/sub_company/Bounds.vue"),
    },
    {
      path: "/c/s/vehicle-layouts",
      name: "Vehicle Layouts",
      component: () => import("./views/sub_company/VehicleLayouts.vue"),
    },
    {
      path: "/c/s/store-name",
      name: "STORE NAME",
      component: () => import("./views/sub_company/Vehicles.vue"),
    },
    {
      path: "/c/s/devices",
      name: "Devices",
      component: () => import("./views/sub_company/Devices.vue"),
    },
    {
      path: "/c/s/branch",
      name: "BRANCH",
      component: () => import("./views/sub_company/Routes.vue"),
    },
    {
      path: "/c/s/price-chart",
      name: "PRICE CHART",
      component: () => import("./views/sub_company/FareMatrixes.vue"),
    },
    {
      path: "/c/s/fuel-stations",
      name: "Fuel Stations",
      component: () => import("./views/sub_company/FuelStations.vue"),
    },
    {
      path: "/c/s/violations",
      name: "Violations",
      component: () => import("./views/sub_company/Violations.vue"),
    },
    {
      path: "/c/s/expenses",
      name: "Expenses",
      component: () => import("./views/sub_company/Expenses.vue"),
    },
    {
      path: "/c/s/passenger-types",
      name: "Passenger Types",
      component: () => import("./views/sub_company/PassengerTypes.vue"),
    },
    {
      path: "/c/s/payment-types",
      name: "Payment Types",
      component: () => import("./views/sub_company/PaymentTypes.vue"),
    },
    {
      path: "/c/s/manual-types",
      name: "Manual Types",
      component: () => import("./views/sub_company/ManualTypes.vue"),
    },
    // {
    //   path: "/c/s/settlements",
    //   name: "Settlements",
    //   component: () => import("./views/sub_company/Settlements.vue"),
    // },
    {
      path: "/c/s/end-of-day",
      name: "End Of Day",
      component: () => import("./views/sub_company/EndOfDay.vue"),
    },
    // {
    //   path: "/c/s/teller-end-of-day",
    //   name: "Teller End Of Day",
    //   component: () => import("./views/sub_company/TellerEndOfDay.vue"),
    // },
    {
      path: "/c/s/remittance-report",
      name: "Remittance Report",
      component: () =>
        import("./views/sub_company/reports/RemittanceReport.vue"),
    },
    // passenger-per-route
    // {
    //   path: "/c/s/passenger-per-route",
    //   name: "Passenger Per Route",
    //   component: () =>
    //     import("./views/sub_company/reports/PassengerPerRoute.vue"),
    // },
    // {
    //   path: "/c/s/passenger-statistics",
    //   name: "Passenger Statistics",
    //   component: () =>
    //     import("./views/sub_company/reports/PassengerStatistics.vue"),
    // },
    {
      path: "/c/s/expenses-report",
      name: "Expenses Report",
      component: () => import("./views/sub_company/reports/ExpensesReport.vue"),
    },
    // {
    //   path: "/c/s/inspections-report",
    //   name: "Inspections Report",
    //   component: () =>
    //     import("./views/sub_company/reports/InspectionsReport.vue"),
    // },
    {
      path: "/c/s/violation-report",
      name: "Violation Report",
      component: () =>
        import("./views/sub_company/reports/ViolationReport.vue"),
    },
    // {
    //   path: "/c/s/trouble-report",
    //   name: "Trouble Report",
    //   component: () => import("./views/sub_company/reports/TroubleReport.vue"),
    // },
    {
      path: "/c/s/device-daily-sales",
      name: "Device Daily Sales",
      component: () =>
        import("./views/sub_company/reports/DeviceDailySales.vue"),
    },
    // pre-sell-daily-transaction
    // {
    //   path: "/c/s/pre-sell-daily-transaction",
    //   name: "Pre-sell Daily Transaction Report",
    //   component: () =>
    //     import("./views/sub_company/reports/PreSellDailyTransactionReport.vue"),
    // },
    // {
    //   path: "/c/s/teller-daily-sales",
    //   name: "Teller Daily Sales",
    //   component: () =>
    //     import("./views/sub_company/reports/TellerDailySales.vue"),
    // },
    // {
    //   path: "/c/s/device-monthly-sales",
    //   name: "Device Monthly Sales",
    //   component: () =>
    //     import("./views/sub_company/reports/DeviceMonthlySales.vue"),
    // },
    // {
    //   path: "/c/s/device-utilization",
    //   name: "Device Utilization",
    //   component: () =>
    //     import("./views/sub_company/reports/DeviceUtilization.vue"),
    // },
    // {
    //   path: "/c/s/dispatch-monitoring",
    //   name: "Dispatch Monitoring",
    //   component: () =>
    //     import("./views/sub_company/reports/DispatchMonitoring.vue"),
    // },
    //
    {
      path: "/c/s/sales-report",
      name: "Sales Report",
      component: () => import("./views/sub_company/reports/SalesReport.vue"),
    },
    // trip sales-report
    // {
    //   path: "/c/s/trip-sales-report",
    //   name: "Trip Sales Report",
    //   component: () =>
    //     import("./views/sub_company/reports/TripSalesReport.vue"),
    // },
    // {
    //   path: "/c/s/device-sales-report",
    //   name: "Device Sales Report",
    //   component: () =>
    //     import("./views/sub_company/reports/DeviceSalesReport.vue"),
    // },
    // {
    //   path: "/c/s/passenger-stats-by-vehicle",
    //   name: "Passenger Stats By Vehicle",
    //   component: () =>
    //     import("./views/sub_company/reports/PassengerByVehicle.vue"),
    // },
    // {
    //   path: "/c/s/passenger-stats-by-time",
    //   name: "Passenger Stats By Time",
    //   component: () =>
    //     import("./views/sub_company/reports/PassengerByTime.vue"),
    // },
    // {
    //   path: "/c/s/passenger-stats-by-zone",
    //   name: "Passenger Stats By Zone",
    //   component: () =>
    //     import("./views/sub_company/reports/PassengerByZone.vue"),
    // },
    // {
    //   path: "/c/s/trip-operation-report",
    //   name: "Trip Operation Report",
    //   component: () =>
    //     import("./views/sub_company/reports/TripOperationReport.vue"),
    // },
    // {
    //   path: "/c/s/internal-audit-report",
    //   name: "Internal Audit Report",
    //   component: () => import("./views/sub_company/reports/InternalAudit.vue"),
    // },
    // {
    //   path: "/c/s/daily-collection-transmittal-report",
    //   name: "Daily Collection Transmittal Report",
    //   component: () =>
    //     import(
    //       "./views/sub_company/reports/DailyCollectionTransmittalReport.vue"
    //     ),
    // },
    // {
    //   path: "/c/s/remittance-exception",
    //   name: "Remittance Exception",
    //   component: () =>
    //     import("./views/sub_company/reports/RemittanceException.vue"),
    // },
    // {
    //   path: "/c/s/baggage-report",
    //   name: "Baggage Report",
    //   component: () => import("./views/sub_company/reports/baggageReport.vue"),
    // },
    // {
    //   path: "/c/s/baggage-financial-report",
    //   name: "Baggage Financial Report",
    //   component: () =>
    //     import("./views/sub_company/reports/baggageFinancialReport.vue"),
    // },
    // {
    //   path: "/c/s/esales",
    //   name: "Esales",
    //   component: () => import("./views/sub_company/reports/EsalesReport.vue"),
    // },
    // //enddd
    {
      path: "/c/s/teller-settlements",
      name: "Teller Settlements",
      component: () => import("./views/sub_company/TellerSettlements.vue"),
    },
  ],
});
